import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/modules/material.module';

import { CreateOutputsIconActionComponent } from './create-outputs-icon-action/create-outputs-icon-action.component';

const COMPONENTS = [
  CreateOutputsIconActionComponent,
];

@NgModule({
  declarations: COMPONENTS,
  imports: [CommonModule, MaterialModule],
  exports: COMPONENTS,
})
export class OutputAssetsActionsModule {}
